import { NgModule } from '@angular/core';
import { CybButtonModule } from './button';
import { CybFooterModule } from './footer';
import { CybHeaderModule } from './header';
import { CybLayoutModule } from './layout';
import { CybNavigationModule } from './navigation';

@NgModule({
  imports: [
    CybButtonModule, CybFooterModule, CybHeaderModule, CybLayoutModule, CybNavigationModule
  ],
  exports: [
    CybButtonModule, CybFooterModule, CybHeaderModule, CybLayoutModule, CybNavigationModule
  ]
})

export class CybersecurityModule { }
